namespace Vit {
    export class SergenGlobalNode extends SergenNodeBase {
        constructor(private globalInfo: GlobalModuleModel) {
            super(null, globalInfo, NodeType.Root);

            this.children.push(new SergenEnumListNode(this, globalInfo.Enums));
        }
        get name(): string {
            return "GlobalModel";
        }
    }
    export class SergenEnumListNode extends SergenNodeBase {
        constructor(parent: SergenNodeBase, private enums: EnumModel[]) {
            super(parent, enums, NodeType.Enum);

            for (const enumModel of enums) {
                this.children.push(new SergenEnumNode(this, enumModel));
            }
        }
        get name(): string {
            return "Enums";
        }

        RemoveFromModel(node: SergenNodeBase) {
            var nodeIndex = this.enums.indexOf(node.nodeData);
            this.enums.splice(nodeIndex, 1);
        }



        public AddEnum(): void {
            var newEnum = <EnumModel>{
                Name: "NewEnum",
                Items: [],
            };
            this.enums.push(newEnum);
            var enumNode = new SergenEnumNode(this, newEnum);
            this.children.push(enumNode);
        }
    }
    export class SergenEnumNode extends SergenNodeBase {
        constructor(parent: SergenNodeBase, public enumModel: EnumModel) {
            super(parent, enumModel, NodeType.EnumItem);

            this.properties.push(new SergenProperty("", enumModel, "Name", EditorType.TextField));

            for (const enumItem of enumModel.Items) {
                this.children.push(new SergenEnumItemNode(this, enumItem));
            }
        }
        get name(): string {
            return this.enumModel.Name;
        }


        public AddItem(): void {
            var n = 1;
            if (this.enumModel.Items.length > 0) {
                n = this.enumModel.Items[this.enumModel.Items.length - 1].Value + 1;
            }
            var newEnumItem = <EnumItem>{
                Name: "Item" + n.toString(),
                Value: n,
            };
            this.enumModel.Items.push(newEnumItem);
            var enumItemNode = new SergenEnumItemNode(this, newEnumItem);
            this.children.push(enumItemNode);
        }

        RemoveFromModel(node: SergenNodeBase) {
            var nodeIndex = this.enumModel.Items.indexOf(node.nodeData);
            this.enumModel.Items.splice(nodeIndex, 1);
        }
    }
    export class SergenEnumItemNode extends SergenNodeBase {
        constructor(parent: SergenNodeBase, private enumItem: EnumItem) {
            super(parent, enumItem, NodeType.EnumField);

            this.properties.push(new SergenProperty("", enumItem, "Name", EditorType.TextField));
            this.properties.push(new SergenProperty("", enumItem, "Comment", EditorType.TextField));
            this.properties.push(new SergenProperty("", enumItem, "Value", EditorType.NumberField));
        }
        get name(): string {
            return this.enumItem.Name;
        }

    }
}
